/**
 * Parse a SubtitleMediaHeaderBox from an IsoView
 *
 * @param view - The IsoView to read data from
 *
 * @returns A parsed SubtitleMediaHeaderBox
 *
 * @group ISOBMFF
 *
 * @beta
 */
export function sthd(view) {
    return view.readFullBox();
}
;
//# sourceMappingURL=sthd.js.map